export default __webpack_public_path__ + "static/entree-charretiere-b6bb919fd26c80a0e9692a29082f933f.svg";